import AbstractCommand from '../AbstractCommand';
import userMessageUnseen from '../../requests/userMessages/userMessageUnseen';

/**
 *
 */
export default class UnseeUserMessageCommand extends AbstractCommand {
	/**
	 *
	 * @param userMessage
	 * @param userMessageStore
	 */
	constructor(userMessage, userMessageStore) {
		super();
		this.userMessage = userMessage;
		this.userMessageStore = userMessageStore;
	}

	/**
	 *
	 * @param success
	 * @param error
	 * @return {Promise<any | never>}
	 */
	execute(success, error) {
		return userMessageUnseen(this.userMessage.id)
			.then((response) => {
				this.userMessage.readAt = null;

				if (success) {
					success(response);
				}
			})
			.catch((err) => {
				if (error) {
					error(err);
				}
			});
	}
}
